import AnalyticsTypes from "./AnalyticsTypes";
import AnalyticsEngine from "../data/AnalyticsEngine";
import DashboardDateUtil from "./DashboardDateUtil";
import Constants from "./Constants";

export default class DatasetUtil {


    // Chart Type Datasets

    public static generateChartDataset(item:GraphSettings, dataset:any, timeInterval:TimeInterval, color:string) {
        if (item.chartType == Constants.CHART_TYPE_LINE || item.chartType == Constants.CHART_TYPE_BAR) {
            return this.generateDefaultChartDataset(item, dataset, timeInterval, color);
        } else if (item.chartType == Constants.CHART_TYPE_DONUT) {
            return this.generateDonutDataset(item, dataset, timeInterval);
        } else if (item.chartType == Constants.CHART_TYPE_WORDCLOUD) {
            return this.generateWordDataset(item, dataset, timeInterval);
        } else {
            //return AnalyticsEngine.getDataset(item, timeInterval);
            return dataset;
        }
    }

    public static generateDonutDataset(item:GraphSettings, dataset:any, timeInterval:TimeInterval): any {
        let data:Array<{label:string, value:number}> = [];
        for (let analyicDataItem of dataset) {
            let found = false;
            for (let dataItem of data) {
                if (analyicDataItem[item.xAxis] == dataItem.label) {
                    dataItem.value += analyicDataItem[item.metric];
                    found = true;
                }
            }
            if (!found) {
                data.push({label:analyicDataItem[item.xAxis], value:analyicDataItem[item.metric]});
            }
        }
        return { data:data }
    }

    public static generateWordDataset(item:GraphSettings, dataset:any, timeInterval:TimeInterval): any {
        let data:Array<{value:string, count:number}> = [];
        for (let analyicDataItem of dataset) {
            let found = false;
            for (let dataItem of data) {
                if (analyicDataItem[item.xAxis] == dataItem.value) {
                    dataItem.value += analyicDataItem[item.metric];
                    found = true;
                }
            }
            if (!found) {
                data.push({value:analyicDataItem[item.xAxis], count:analyicDataItem[item.metric]});
            }
        }
        return data;
    }

    public static generateDefaultChartDataset(item:GraphSettings, dataset:any, timeInterval:TimeInterval, color:string): any {
        console.log("Getting dataset for " + AnalyticsTypes.getLabel(item.dataSource));
        if (!dataset) {
            console.error("Could not find dataset for analytic: " + item.dataSource);
            return null
        }

        let datasets = [];
        if (item.group) {
            let groups = AnalyticsEngine.getUniqueDataValues(item, item.group);
            for (let group of groups) {
                let yAxisData = [];
                for (let analyticDataItem of dataset) {
                    if (analyticDataItem[item.group] == group) {
                        yAxisData.push(analyticDataItem[item.metric]);
                    }
                }
                datasets.push({color: color, label: group, data: yAxisData})
            }
        } else {
            let metrics = item.metric.split(",");
            console.log(dataset);
            for (let metricItem of metrics) {
                let yAxisData = [];
                console.log(metricItem);
                for (let analyticDataItem of dataset) {
                    yAxisData.push(analyticDataItem[metricItem]);
                }
                datasets.push({color: color, label: metricItem, data: yAxisData});
            }
        }

        let data = {
            //stats: GraphUtil.generateStats(GraphUtil.aggregate(item.graphName, item.metric, analyticDataset), color),
            data: {
                labels: item.xAxis != "date" ? this.getXAxisValues(item.xAxis, dataset) : DashboardDateUtil.getTooltipDates(timeInterval),
                ticks: item.xAxis != "date" ? this.getXAxisValues(item.xAxis, dataset) : DashboardDateUtil.getTickDates(timeInterval),
                datasets: datasets
            },
        };

        return data;
    }

    // Private methods

    private static getXAxisValues(xAxis:string, dataset:Array<any>) {
        let axisValues:Array<any> = [];
        for (let dataItem of dataset) {
            let found = false;
            for (let axisValue of axisValues) {
                if (axisValue == dataItem[xAxis]) { found = true; }
            }
            if (!found) {
                axisValues.push(dataItem[xAxis]);
            }
        }
        return axisValues;
    }
}